import { ChangeEvent, FC } from "react";

import { CarouselScrollBarProps } from "./CarouselScrollBar.types";
import { StyledCarouselScrollBar } from "./CarouselScrollBar.styles";
import Box from "../../layout/boxes/Box";

const CarouselScrollBar: FC<CarouselScrollBarProps> = ({
	className,
	currentPage,
	pageCount,
	slidesToShow,
	sliderNode,
}) => {
	const handleScrollChange = (e: ChangeEvent<HTMLInputElement>) => {
		const nextSlide = Number(e.target.value);

		if (sliderNode.current) {
			sliderNode.current.slickGoTo(nextSlide * slidesToShow);
		}
	};
	return (
		<Box
			display="flex"
			position="relative"
			marginY="lg"
			height="8px"
			overflow="hidden"
		>
			<StyledCarouselScrollBar
				className={className}
				tabIndex={0}
				pageCount={pageCount}
				currentPage={currentPage}
				onChange={handleScrollChange}
				type="range"
				min={0}
				step={1}
				value={currentPage}
				max={pageCount - 1}
			/>
		</Box>
	);
};

export default CarouselScrollBar;
